import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-five',
    templateUrl: './without-animation-home-five.component.html',
    styleUrls: ['./without-animation-home-five.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeFiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
